import { render } from "./RatingInput.vue?vue&type=template&id=0f97e272&scoped=true&ts=true"
import script from "./RatingInput.vue?vue&type=script&lang=ts"
export * from "./RatingInput.vue?vue&type=script&lang=ts"

import "./RatingInput.vue?vue&type=style&index=0&id=0f97e272&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f97e272"]])

export default __exports__